import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'

export const lMUgcSourceApi = createApi({
  reducerPath: 'lMUgcSourceApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['UgcSourceLinks'],
  endpoints: builder => ({
    getUgcSourceLinks: builder.query({
      query: (params) => ({
        url: `/links/ugc-source/`,
        params,
      }),
      providesTags: ['UgcSourceLinks']
    }),
    getUgcSourceAggregateLinks: builder.query({
      query: (params) => ({
        url: `/links/ugc-source/aggregate-by-campaign/`,
        params
      }),
      providesTags: ['UgcSourceLinks']
    }),

    getUgcSourceAggregateDomain: builder.query({
      query: ({ campaignId, ...params }) => ({
        url: `/links/ugc-source/${campaignId}/aggregate-by-domain/`,
        params,
      }),
      providesTags: ['UgcSourceLinks']
    }),
    markUgcSource: builder.mutation({
      query: body => ({
        url: `/links/ugc-source/mark/`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['UgcSourceLinks']
    }),
    createSource: builder.mutation({
      query: body => ({
        url: '/links/ugc-source/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['UgcSourceLinks']
    }),
    changeRemovalStatus: builder.mutation({
      query: body => ({
        url: '/links/ugc-source/change-removal-status/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['UgcSourceLinks']
    })
  })
})

export const {
  useGetUgcSourceLinksQuery,
  useLazyGetUgcSourceLinksQuery,
  useGetUgcSourceAggregateLinksQuery,

  useGetUgcSourceAggregateDomainQuery,
  useMarkUgcSourceMutation,
  useCreateSourceMutation,
  useChangeRemovalStatusMutation
} = lMUgcSourceApi
